var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block"},[_c('el-form',{attrs:{"inline":true}},[_c('el-form-item',[_c('el-pagination',{attrs:{"current-page":_vm.currentPage,"page-size":_vm.pageSize,"total":_vm.total},on:{"current-change":_vm.handleCurrentChange}})],1),_vm._v(" "),_c('el-form-item',[_c('button',{staticClass:"btn-go",on:{"click":_vm.goPage}},[_vm._v("GO")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5eae8f16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageIndex.vue
// module id = null
// module chunks = 